
export const LIB_LANG = {
  bootstrap: {
    en: 'en',
    uk: 'uk',
    ru: 'ru',
    'es-419': 'es',
    es: 'es',
    pl: 'pl',
    fr: 'fr',
    it: 'it',
    de: 'de',
    pt: 'pt',
    tr: 'tr',
    vi: 'vi'
  }
} as const;
